// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const TicketStatus = {
  "OPEND": "OPEND",
  "WAITINGRESPONSE": "WAITINGRESPONSE",
  "ARCHIVED": "ARCHIVED"
};

const BonusType = {
  "MARKETING_FEE_1": "Marketing_Fee_1",
  "MANAGER_FEE_2": "Manager_Fee_2",
  "BONUS_TEAM_3": "Bonus_Team_3",
  "REVENUE_BONUS_4": "Revenue_Bonus_4",
  "SPONSOR_BONUS_5": "Sponsor_Bonus_5",
  "MANAGER_BONUS_6": "Manager_Bonus_6",
  "AMBASSADOR_BONUS_7": "Ambassador_Bonus_7",
  "COMPANY_BONUS_8": "Company_Bonus_8",
  "DIRECTOR_BONUS_9": "Director_Bonus_9"
};

const PermissionType = {
  "CLIENT": "CLIENT",
  "COMMERCIAL": "COMMERCIAL",
  "ADMINISTRATOR": "ADMINISTRATOR"
};

const BonusStatus = {
  "PAGATO": "Pagato",
  "NON_PAGATO": "NonPagato"
};

const { User, Faq, Bonus, Contract, Team, SupportRequest, Ticket, Notification, BonusGenerationProcess, S3Object } = initSchema(schema);

export {
  User,
  Faq,
  Bonus,
  Contract,
  Team,
  SupportRequest,
  Ticket,
  Notification,
  BonusGenerationProcess,
  TicketStatus,
  BonusType,
  PermissionType,
  BonusStatus,
  S3Object
};